<template>
  <div class="question">
    <!-- 资源分类 -->
    <resource-classify
      :courseId="courseId"
      :subjectId="subjectId"
      :from="'question'"
      @changeFunc="changeFunc"
    ></resource-classify>
    <!-- handle -->
    <div class="handle">
      <div class="btns_area">
        <div class="custom-btn custom-full-btn" @click="addBtn()">添加试题</div>
        <div class="custom-btn custom-empty-btn" @click="deleteBtn()">
          批量删除
        </div>
      </div>
      <!-- <el-input
        placeholder="搜索"
        suffix-icon="el-icon-search"
        v-model="searchParams.name"
        size="mini"
        clearable
        @clear="searchFunc"
        @keyup.enter.native="searchFunc"
      >
      </el-input> -->
      <n-search-input @searchInput="searchFunc"></n-search-input>
    </div>
    <!-- list -->
    <div>
      <n-table
        v-loading="loading"
        :tableData="tableData"
        :tableHeader="QuestionTableHeader"
        :ISChangeCheckout="true"
        :TableHeight="TableHeight"
        @operation="operation"
      ></n-table>

      <Pagination
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="total, sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
      ></Pagination>
    </div>

    <!-- 弹窗 -->
    <n-dialog
      :title="dialogTitle"
      :dialogVisible="addQuestionShow"
      :width="dialogWidth"
      :courseId="courseId"
      :subjectId="subjectId"
      :questionId="questionId"
      :dialogType="dialogType"
      :deleteNum="deleteNum"
      :deleteName="deleteName"
      @closeDialog="closeDialog"
    ></n-dialog>

  </div>
</template>

<script>
import * as api from '../../../../../api/newCourseApi.js'
import resourceClassify from "../../../components/resourceClassify.vue";
import Pagination from "../../../../../components/paginator/paginator.vue";
import { QuestionTableHeader } from "../../../global/table_header_data";

export default {
  name: "question",
  components: {
    resourceClassify,
    Pagination,
  },
  props: {
    courseId: {
      type: [Number, String],
      default: "",
    },
    subjectId: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      // TableHeight: '442px',
      loading: false,
      QuestionTableHeader: QuestionTableHeader,
      TableHeight: "0px",
      searchParams: {
        // 查询参数
        categoryId: "", // 资源分类id
        questionType: "", // 题型id
        difficulty: "", // 难度,1:简单，2:中等，3:困难
        name: "", // 资源名称
      },
      tableData: [],
      multipleSelection: [],
      pageTotal: {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      // dialog
      dialogTitle: "",
      dialogWidth: "",
      dialogType: "",
      addQuestionShow: false,
      questionId: "",
      deleteNum: "",
      deleteName: "",
    };
  },
  created() {},
  mounted() {
    this.findPageResource();
  },
  methods: {
    // 查询list
    findPageResource() {
      this.loading = true;
      api.FindPageResource({
        "courseId": this.courseId,            //课程id
        "categoryId": this.searchParams.categoryId,         //资源分类id
        "name": this.searchParams.name,  //资源名称
        "difficulty": this.searchParams.difficulty,	     //难度,1:简单，2:中等，3:困难
        "questionType": this.searchParams.questionType,        //内部题型 (1:单选题，2：多选题，3：判断题，4:填空题，5：问答题，6：组合题，7：连线题，8：配伍选择题，9：操作题，10：附件题)
        "pageNum": this.pageTotal.currentPage,
        "pageSize": this.pageTotal.pageSize,
        "resourceType": 3        //资源类型(1:ppt,2:文件,3:试题,4:视频,5:试卷,6:共享资源，7素材（查询：视频、ppt、文件）)
      }).then(res => {
        if (res.code == "0") {
          let datas = res.data.list;
          // this.TableHeight = datas.length == 0 ? '335px' : ( datas.length + 1 ) * 40 + datas.length + 1 + 'px';
          this.TableHeight = datas.length == 0 ? '335px' : datas.length * 40 + 41 + 'px';
          [].forEach.call(datas, item => {
              if (item.taskName == null || item.taskName == "") {
                let str = item.questionContent
                if(str){
                  let content = this.$delHtmlTag.delHtmlTag(str)
                  if(content.substring(0,100).length>=100){
                    item.taskName = `${content.substring(0,100)}...`;
                  }else{
                    item.taskName = `${content.substring(0,100)}`;
                  }
                }
              }
            })
          this.tableData = datas;
          this.pageTotal.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        console.log(err);
      }).finally(()=>{
        this.loading = false;
      })
    },
    searchFunc(input_val) {
      this.searchParams.name = input_val;
      this.pageTotal.currentPage = 1;
      this.findPageResource();
    },
    changeFunc(id, type) {
      // console.log(id, type);
      /**
       * @param type ['resource', 'questionType', 'difficulty']
       */
      type == "resource" ? this.searchParams.categoryId = id : 
      type == "questionType" ? this.searchParams.questionType = id : 
      this.searchParams.difficulty = id;
      this.findPageResource();
    },

    // table 操作
    operation(type, RowData) {
      if (type == "selectChange") {
        // 选中
        this.multipleSelection = RowData;
      } else if (type == "preview") {
        this.questionId = RowData.id;
        this.previewBtn();
      } else if (type == "delete") {
        this.multipleSelection = [RowData];
        this.deleteBtn();
      }
    },
    // addBtn
    addBtn() {
      this.dialogTitle = "添加试题";
      this.dialogWidth = "850px";
      this.dialogType = "addQuestion";
      this.addQuestionShow = true;
    },
    // previewBtn
    previewBtn() {
      this.dialogTitle = "试题预览";
      this.dialogWidth = "880px";
      this.dialogType = "questionPreview";
      this.addQuestionShow = true;
    },
    // deleteBtn
    deleteBtn() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择试题");
        return
      }
      this.deleteNum = this.multipleSelection.length;
      this.deleteName = '<div class="question_title">'+this.multipleSelection[0].taskName+'</div>'
      // this.deleteName = this.multipleSelection[0].taskName ? 
      //                   this.multipleSelection[0].taskName : 
      //                   `${this.multipleSelection[0].questionTypeName} ${this.multipleSelection[0].id}`;
      this.dialogTitle = "提示";
      this.dialogWidth = "400px";
      this.dialogType = "deleteQuestion";
      this.addQuestionShow = true;
    },

    closeDialog() {
      this.addQuestionShow = false;
      this.findPageResource();
    },

    // 分页
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      // this.$refs.question_testArea.scrollTop = 0;
      this.findPageResource();
    },
    handleSizeChange(val) {
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      // this.$refs.question_testArea.scrollTop = 0;
      this.findPageResource();
    },


  },
};
</script>

<style scoped lang="scss">
.question {
  height: 100%;
  overflow-y: auto;
  padding: 10px 24px;
  box-sizing: border-box;
  .handle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btns_area {
      display: flex;
    }
    .el-input {
      width: 200px;
      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .table {
    margin-top: 8px;
    border-top: 1px solid #ededf0;
    /deep/ .el-table__header-wrapper .cell {
      color: #767484;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    /deep/ .el-table__row {
      background: #f5f5f7;
    }
    /deep/ .el-table__row--striped {
      background: #fff;
    }
    /deep/ .el-table__body-wrapper .cell {
      color: #0f0d11;
      font-size: 12px;
    }
    .table_delete_btn {
      color: #1890ff;
      font-size: 12px;
    }
  }
  /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_course_module/editCourse/question/index.vue